<template>
  <v-row>
    <v-col
      v-for="(item, i) in tabs"
      :key="i"
      cols="auto"
    >
      <v-btn
        :text="!selected(item)"
        :to="item.id"
        exact
      >
        {{ item.name }}
      </v-btn>
    </v-col>
    <v-spacer />
  </v-row>
</template>

<script>
export default {
  name: 'UserHeader',
  components: {},
  data() {
    return {
      tabs: [
        { id: '/users', name: 'Users' },
        { id: '/users/contributors', name: 'Contributors' },
        { id: '/users/designers', name: 'Designers' }
      ]
    };
  },
  computed: {
    id() {
      return this.$route.path;
    },
    selected() {
      return (item) => {
        return this.id === item.id;
      };
    }
  },
  methods: {}
};
</script>
